// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"582":"b9cf800a","4189":"b9cf800a","7092":"b9cf800a","7995":"b9cf800a"}[chunkId] + ".chunk.css";
};